import { inject, injectable } from "inversify";
import { type IService, Logger } from "@designboticteam/core";
import { MapStoreService, type WmsSource, type WmsSourceId } from "..";

@injectable()
class WmsService implements IService {
	public readonly serviceName = "🗺️ WmsService";
	private readonly logger = new Logger(`🌍 MAP | ${this.serviceName}`, {
		color: "#ffffff",
		backgroundColor: "#00aa00",
	});

	constructor(@inject(MapStoreService) private mapStore: MapStoreService) {
		this.logger.log("constructed");
	}

	public initialize(): void {
		this.logger.log("initialized");
	}

	public dispose(): void {
		this.logger.log("disposed");
	}

	public addLayer(source: WmsSource): void {
		this.mapStore.setState((state) => {
			const next = new Map(state.sources.wms);
			next.set(source.id, source);

			return {
				sources: {
					...state.sources,
					wms: next,
				},
			};
		});
	}

	public removeLayer(sourceId: WmsSourceId): void {
		this.mapStore.setState((state) => {
			if (!state.sources.wms.has(sourceId)) {
				return state;
			}

			const next = new Map(state.sources.wms);
			next.delete(sourceId);

			return {
				sources: {
					...state.sources,
					wms: next,
				},
			};
		});
	}

	public updateLayer(sourceId: WmsSourceId, patch: Partial<WmsSource>): void {
		this.mapStore.setState((state) => {
			const current = state.sources.wms.get(sourceId);

			if (current === undefined) {
				return state;
			}

			const next = new Map(state.sources.wms);
			next.set(sourceId, { ...current, ...patch });

			return {
				sources: {
					...state.sources,
					wms: next,
				},
			};
		});
	}
}

export { WmsService };
